/** Render top → bottom: GK, DEF, MID, FWD (GK row at top of pitch) */
export const TEMPLATE_PITCH_POS_ORDER = [1, 2, 3, 4] as const

export type TemplatePitchPos = (typeof TEMPLATE_PITCH_POS_ORDER)[number]
